import React from 'react'
import IndexPage from '../index-table/IndexPage'
import TWSCustomerAPIService from '@lib/api-services/TWSCustomerApiService';
import TWSCustomersAPIService from '@lib/api-services/TWSCustomersApiService';

interface SelfProps {
    options: any;
    columns: any;
    results: any;
    paging: any;
    filter: any;
}

class TWSCustomerIndexPage extends React.Component<SelfProps> {
    render() {
        return (
            <IndexPage
                title={__("Customers")}
                options={this.props.options}
                columns={this.props.columns}
                results={this.props.results}
                paging={this.props.paging}
                filter={this.props.filter}
                indexApiService={TWSCustomersAPIService}
                editApiService={TWSCustomerAPIService}
            />
        );
    }
}

window.components.TWSCustomerIndexPage = TWSCustomerIndexPage